import Header from './components/Header';
import Hero from './components/Hero';
import MediaSection from './components/MediaSection';
import AboutSection from './components/AboutSection';
import FeaturesSection from './components/FeaturesSection';
import UpdatesSection from './components/UpdatesSection';
import AppSection from './components/AppSection';
import FaqSection from './components/FaqSection';
import CardsSection from './components/CardsSection';
import CommentsSection from './components/CommentsSection';
import CarouselSection from './components/CarouselSection';
import TopicsSection from './components/TopicsSection';
import IndexSection from './components/IndexSection';
import ContactSection from './components/ContactSection';
import RankingSection from './components/RankingSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-900">
      <Header />
      <main>
        <Hero />
        <MediaSection />
        <AboutSection />
        <FeaturesSection />
        <UpdatesSection />
        <AppSection />
        <FaqSection />
        <CardsSection />
        <CommentsSection />
        <CarouselSection />
        <TopicsSection />
        <IndexSection />
        <ContactSection />
        <RankingSection />
      </main>
      <Footer />
    </div>
  );
}